module.exports = __webpack_public_path__ + "img/cooking-show.30169fbd.webp";